import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemGridValue
} from "../../report-design-item";

@Pipe({
  name: "asGridValue",
  standalone: false
})
export class ReportItemConfigAsGridValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemGridValue {
    return <ReportDesignItemGridValue>value;
  }
}
